<template>
  <div :class="{ 'alfa-design': alfaDesign, 'default-design': !alfaDesign }">
    <md-dialog
      md-open-from="#forgotPassword"
      md-close-to="#forgotPassword"
      ref="forgotPassword"
    >
      <md-dialog-title>Password reset</md-dialog-title>

      <md-dialog-content>
        <div>Please enter your email address.</div>
        <form
          @submit.prevent="closeDialog('forgotPassword', true)"
          class="forgot-password-form"
          :class="{ 'default-forgot-password-dialog-content': !alfaDesign }"
        >
          <md-input-container>
            <label>Email</label>
            <md-input type="email" name="email" v-model="forgottenEmail" />
          </md-input-container>
        </form>
      </md-dialog-content>

      <md-dialog-actions
        class="forgot-password-actions"
        :class="{ 'default-forgot-password-actions': !alfaDesign }"
      >
        <md-button
          class="md-primary"
          @click="closeDialog('forgotPassword', false)"
        >
          Cancel
        </md-button>
        <md-button
          class="md-primary"
          @click="closeDialog('forgotPassword', true)"
        >
          Ok
        </md-button>
      </md-dialog-actions>
    </md-dialog>
    <div class="auth-area">
      <div class="alfa-auth-window" v-if="alfaDesign">
        <div class="alfa-auth-info">
          <h1>The algorithm factory</h1>
          <h2>Let's get started</h2>
          <div class="line"></div>
          <div class="alfa-logo-holder">
            <span>
              <transition-group name="list-complete">
                <img
                  class="temp-image"
                  v-for="(url, index) in imagesUrls"
                  :src="url"
                  v-if="index === imageNum"
                  :key="index + url"
                  alt="Quinyx logo"
                />
              </transition-group>
            </span>
          </div>
        </div>
        <div class="alfa-auth-form">
          <h2>Enter your credentials</h2>
          <form @submit.prevent="login" class="auth-form">
            <div class="custom-input-block">
              <md-input-container>
                <label>Email or Username</label>
                <md-input name="email" type="text" v-model="user.username" />
              </md-input-container>
            </div>
            <div class="custom-input-block">
              <md-input-container md-has-password>
                <label>Password</label>
                <md-input
                  name="password"
                  type="password"
                  v-model="user.password"
                />
              </md-input-container>
            </div>
            <div class="auth-helpers">
              <div class="auth-helpers-part">
                <md-checkbox v-if="!isExternal" v-model="remember">
                  Remember me
                </md-checkbox>
                <md-checkbox v-if="isExternal" v-model="rememberAll">
                  Remember me
                </md-checkbox>
              </div>
              <div class="auth-helpers-part">
                <div id="forgotPassword" @click="openDialog('forgotPassword')">
                  Forgot your password
                </div>
              </div>
            </div>
            <div class="auth-actions">
              <md-button
                type="submit"
                @submit="login"
                class="md-raised md-primary"
              >
                Log in
              </md-button>
            </div>
            <div class="request-demo">
              <h2>No account yet?</h2>
              <a
                href="https://widgetbrain.com/demo/"
                target="_blank"
                class="request-demo-link"
              >
                Request a demo
              </a>
            </div>
          </form>
        </div>
      </div>
      <div class="auth-window" v-else>
        <div class="auth-logo">
          <img :src="logoUrl" alt="Quinyx logo" />
        </div>
        <form @submit.prevent="login" class="auth-form">
          <md-input-container>
            <label>Email or Username</label>
            <md-input name="email" type="text" v-model="user.username" />
          </md-input-container>

          <md-input-container md-has-password>
            <label>Password</label>
            <md-input name="password" type="password" v-model="user.password" />
          </md-input-container>
          <div class="auth-helpers">
            <div class="auth-helpers-part">
              <md-checkbox v-if="!isExternal" v-model="remember">
                Remember me
              </md-checkbox>
              <md-checkbox v-if="isExternal" v-model="rememberAll">
                Remember me
              </md-checkbox>
            </div>
            <div class="auth-helpers-part">
              <div id="forgotPassword" @click="openDialog('forgotPassword')">
                Forgot your password
              </div>
            </div>
          </div>
          <div class="auth-actions">
            <md-button
              type="submit"
              @submit="login"
              class="md-raised md-primary"
            >
              Log in
            </md-button>
            <multiselect
              v-model="selectedSso"
              :options="ssoOptions"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="false"
              placeholder="Log in With SSO"
              selectLabel=""
              label="name"
              deselectLabel="remove"
              class="sso-button"
            />
            <md-button
              @click="SSOLogin()"
              class="md-raised md-primary sso-submit-button"
              :class="{ 'sso-submit-button-disabled': !selectedSso }"
            >
              <md-icon>keyboard_tab</md-icon>
            </md-button>
          </div>
          <div class="request-demo">
            <a
              href="https://widgetbrain.com/demo/"
              target="_blank"
              class="request-demo-link"
            >
              Or request a demo
            </a>
          </div>
        </form>
      </div>
    </div>

    <md-dialog ref="errorDialog" :class="'error-dialog'">
      <md-dialog-title>{{ dialogErrorMessage }}</md-dialog-title>
      <md-dialog-content
        class="error-dialog-content"
        :class="{ 'default-error-dialog-content': !alfaDesign }"
      >
        <div v-if="dialogErrorCode === 500">
          <p>Please try the following:</p>
          <ul>
            <li>
              <a v-bind:href="systemStatusUrl" target="_blank">
                Check system status
              </a>
            </li>
            <li>
              <a v-bind:href="faqUrl" target="_blank">
                Check FAQ: Why I cannot access my application?
              </a>
            </li>
            <li>
              <a v-bind:href="'mailto:' + widgetBrainSupportEmail">
                Contact Widget Brain Support
              </a>
            </li>
          </ul>
        </div>
        <div v-else-if="dialogErrorCode === 403">
          <p>Please try the following:</p>
          <ul>
            <li>
              <a v-bind:href="faqUrl" target="_blank">
                Check FAQ: Why I cannot access my application?
              </a>
            </li>
            <li>
              <a v-bind:href="'mailto:' + widgetBrainSupportEmail">
                Contact Widget Brain Support
              </a>
            </li>
          </ul>
        </div>
        <div v-else-if="dialogErrorCode === 401">
          <ul>
            <li>
              <a @click="openDialog('forgotPassword')">Forgot your password</a>
            </li>
            <li><a v-bind:href="faqUrl" target="_blank">Check Login FAQ</a></li>
          </ul>
        </div>
      </md-dialog-content>
      <md-dialog-actions
        class="error-dialog-actions"
        :class="{ 'default-error-dialog-actions': !alfaDesign }"
      >
        <md-button class="md-primary" @click="closeErrorDialog">
          Close
        </md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import config from "../helpers/config";
import managedata from "../helpers/managedata";
import params from "../helpers/params";
import utils from "../helpers/utils";
import { mapGetters } from "vuex";
import auth0 from "auth0-js";
import logoUrl from "../../images/quinyx-green.svg";
import Multiselect from "vue-multiselect";

export default {
  name: "Login",
  components: {
    Multiselect,
  },
  data() {
    return {
      selectedSso: null,
      ssoOptions: [],
      logoUrl: logoUrl,
      isExternal: false,
      loginAppId: null,
      appId: params.getParameterValue("APP_ID"),
      apiUrl: params.getParameterValue("API_URL"),
      user: {
        username: null,
        password: null,
      },
      remember: true,
      rememberAll: true,
      forgottenEmail: null,
      faqUrl: config.faqUrl,
      faqUrlLoginAnchor: config.faqUrlLoginAnchor,
      systemStatusUrl: config.systemStatusUrl,
      widgetBrainSupportEmail: config.widgetBrainSupportEmail,
      imagesUrls: [
        "../../static/factory.svg",
        "../../static/screen.png",
        "../../static/arm.png",
      ],
      imageNum: 0,
      auth0Config: {
        ...config.auth0Config,
        redirectUri: params.getParameterValue("UI_URL") + "/#/login",
        audience: "https://" + config.auth0Config.domain + `/userinfo`,
        scope: "openid profile email",
        responseType: "code",
        responseMode: "query",
      },
    };
  },
  computed: {
    ...mapGetters([
      "WBToken",
      "userId",
      "dialogErrorMessage",
      "dialogErrorMessageRandom",
      "dialogErrorCode",
    ]),
    alfaDesign() {
      return !!this.$route.query.alfaDesign;
    },
    customApiUrl() {
      return this.$route.query.apiUrl;
    },
    neoUrl() {
      return params.getParameterValue("NEO_URL");
    },
  },
  watch: {
    dialogErrorMessageRandom(newValue, oldValue) {
      this.$refs.errorDialog.open();
    },
  },
  created() {
    this.getSsoOptions();

    this.loginAppId = this.$route.query.loginAppId
      ? this.$route.query.loginAppId
      : this.appId;

    this.auth0Config.redirectUri =
      window.location.origin + "/#" + this.$route.path;

    this.auth0 = new auth0.WebAuth({
      ...this.auth0Config,
      state: this.$route.path + "|" + this.loginAppId,
    });
  },
  methods: {
    getSsoOptions() {
      managedata
        .getSsoOptions()
        .then((res) => {
          this.ssoOptions = res.body;

          //ssoOptions filtering - okta&azure:
          this.ssoOptions = this.ssoOptions.filter((option) => {
            return option.name === "Okta" || option.name === "Azure";
          });
          if (utils.isQuinyx()) {
            this.ssoOptions.push({
              name: "Quinyx",
              tagName: "quinyxNeo",
            });
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        });
    },
    login() {
      // Make email input data case insensitive
      this.user.username = this.user.username.toLowerCase();
      if (this.checkEmail(this.user.username)) {
        this.user.email = this.user.username;
        delete this.user.username;
      }

      this.$store
        .dispatch("login", {
          user: this.user,
          remember: this.remember,
          rememberAll: this.rememberAll,
          isExternal: this.isExternal,
        })
        .then((res) => {
          if (this.isExternal) {
            const message = {
              message: "loggedIn",
              token: this.WBToken,
              userId: this.userId,
              remember: this.rememberAll || this.remember,
            };

            window.parent.postMessage(message, "*");
            // window.parent.location.reload();
          }
        })
        .catch((err) => {
          console.log("Error: ", err);
          if (this.isExternal) {
            window.parent.postMessage({ message: "loggedOut" }, "*");
          }
        });
    },
    loginWithAuth0(authorizationCode, callbackUrl, appId) {
      fetch(this.apiUrl + `/api/WBUsers/authorizeByAuth0Code`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ authorizationCode, callbackUrl, appId }),
      })
        .then((res) => res.json())
        .then((body) =>
          this.$store.dispatch("setupToken", {
            body,
            remember: this.remember,
            rememberAll: this.rememberAll,
            isExternal: this.isExternal,
          })
        )
        .then(() => {
          if (!this.isExternal) {
            return;
          }

          const message = {
            message: "loggedIn",
            token: this.WBToken,
            userId: this.userId,
            remember: this.rememberAll || this.remember,
          };

          window.parent.postMessage(message, "*");
          window.parent.location.reload();
        })
        .catch((err) => {
          console.error(err.message);
        });
    },
    checkEmail(email) {
      let re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
      return re.test(email);
    },
    openDialog(ref) {
      this.$refs.errorDialog.close();
      this.$refs[ref].open();
    },
    closeDialog(ref, isConfirmed) {
      if (isConfirmed) {
        this.$store.dispatch("forgotPassword", this.forgottenEmail);
      }
      this.$refs[ref].close();
    },
    checkToken() {
      return new Promise((resolve) => {
        const token = this.WBToken || localStorage.getItem("WBToken");
        const userId = this.userId || localStorage.getItem("userId");

        if (!(token && userId)) {
          resolve(false);
          return;
        }

        if (this.$route.query.logout === "true") {
          this.$store.commit("LOGOUT");
          resolve(false);
        } else {
          this.$store
            .dispatch("getUser")
            .then((res) => {
              const message = {
                message: "loggedIn",
                token: token,
                userId: userId,
                remember: true,
              };
              window.parent.postMessage(message, "*");

              resolve(true);
            })
            .catch((err) => {
              resolve(false);
            });
        }
      });
    },
    closeErrorDialog() {
      this.$refs.errorDialog.close();
    },
    auth0Login() {
      this.auth0.authorize();
    },
    SSOLogin() {
      if (this.selectedSso.tagName === "quinyxNeo") {
        window.parent.postMessage("quinyxLogin", "*");
        setTimeout(() => {
          window.open(this.neoUrl, "_blank");
        }, 1000);
      } else {
        window.location.href = `${this.apiUrl}/auth/openid/login?config=${this.selectedSso.tagName}&appId=${this.loginAppId}`;
      }
    },
  },
  mounted() {
    const self = this;
    const currentUrl = new URL(window.location.href);

    if (self.alfaDesign) {
      setInterval(() => {
        if (self.imageNum === 2) {
          self.imageNum = 0;
        } else {
          self.imageNum++;
        }
      }, 3000);
    }

    if (this.customApiUrl) {
      this.$store.dispatch("setCustomApiUrl", this.customApiUrl);
    }

    window.addEventListener("message", (event) => {
      const {
        authorizationCode = null,
        appId = null,
        callbackUrl = null,
        id = null,
        userId = null,
      } = event.data;

      const redirectUrl = callbackUrl || self.auth0Config.redirectUri;

      if (authorizationCode && appId && !self.WBToken && !self.userId) {
        self.loginWithAuth0(authorizationCode, redirectUrl, appId);
      }

      if (id && userId) {
        self.$store.dispatch("setupToken", {
          body: { id, userId },
          remember: true,
        });
      }
    });

    const state = currentUrl.searchParams.get("state") || "|";
    const [externalState = "", appId = this.appId] = state.split("|");

    const access_token = currentUrl.searchParams.get("access_token");
    Promise.resolve(access_token)
      .then((access_token) => {
        if (!access_token) {
          return;
        }

        const body = {
          id: access_token,
          userId: currentUrl.searchParams.get("userId"),
        };

        return self.$store
          .dispatch("setupToken", {
            body,
            remember: self.remember,
            rememberAll: self.rememberAll,
            isExternal: self.isExternal,
          })
          .then(() => {
            const message = {
              token: body.id,
              userId: body.userId,
              remember: true,
            };
            window.parent.postMessage(message, "*");
          });
      })
      .then(
        () =>
          this.$route.path === "/externallogin" ||
          externalState === "/externallogin"
      )
      .then((isExternal) => {
        if (isExternal) {
          self.isExternal = true;
          return self.checkToken();
        }

        return false;
      })
      .then((isLoggedId) => {
        if (isLoggedId) {
          return;
        }

        const authorizationCode = currentUrl.searchParams.get("code");
        const callbackUrl = self.auth0Config.redirectUri;

        if (authorizationCode && appId && !self.WBToken && !self.userId) {
          self.loginWithAuth0(authorizationCode, callbackUrl, appId);
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  },
};
</script>

<style>
.alfa-design {
  min-height: 100vh;
  background-color: #2e73c3;
}

.alfa-design .request-demo {
  border-top: 1px dashed #0c5ac5;
  margin-top: 100px;
  display: block;
  padding-top: 10px;
}

.alfa-design .request-demo h2 {
  font-family: "Bebas", sans-serif;
  color: #0c5ac5;
  font-size: 20px;
  margin-bottom: 0;
}

.alfa-design .request-demo a {
  color: #ea227d !important;
  text-decoration: underline;
  text-transform: unset;
  font-family: Roboto;
}

.alfa-design .auth-helpers-part {
  font-family: Roboto;
}

.alfa-design .auth-area {
  align-items: center !important;
}

.alfa-design .auth-actions button {
  width: 200px;
  margin: 10px auto;
  background-color: #ea227d !important;
  color: #fff;
  font-family: "Bebas", sans-serif;
  font-size: 20px;
  border: 1px solid #fff;
  box-shadow: 0 0 40px rgba(0, 0, 0, 0.3);
}

.alfa-auth-window {
  width: 800px;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
}

.alfa-auth-form {
  border-radius: 10px;
  background-color: #fff;
  padding: 30px 20px;
  width: 350px;
}

.alfa-auth-form h2 {
  font-size: 30px;
  color: #ea227d;
  font-family: "Bebas", sans-serif;
  margin: 0;
  margin-bottom: 15px;
}

.alfa-auth-info {
  width: 400px;
}

.alfa-auth-info h1 {
  font-size: 30px;
  color: #f9e900;
  margin: 0;
  font-family: "Bebas", sans-serif;
  line-height: 30px;
}

.alfa-auth-info h2 {
  font-size: 50px;
  margin: 0 0 10px;
  color: #fff;
  font-family: "Bebas", sans-serif;
  line-height: 50px;
}

.line {
  width: 60px;
  height: 5px;
  background-color: #f9e900;
}

.custom-input-block .md-input-container {
  margin: 0;
}

.custom-input-block .md-input-container:after {
  display: none;
}

.custom-input-block .md-input-container.md-has-value input,
.custom-input-block .md-input-container.md-has-value textarea {
  color: #8dc7f7 !important;
  text-shadow: 0 0 0 #8dc7f7 !important;
}

.custom-input-block .md-input-container label {
  color: #8dc7f7 !important;
}

.custom-input-block .md-input-container .md-icon:not(.md-icon-delete) {
  color: #8dc7f7 !important;
}

.custom-input-block {
  border: 1px solid #8db9ec;
  background: #e2f2fe;
  margin: 8px 0;
  padding: 0 10px 6px;
  border-radius: 4px;
}

.alfa-logo-holder {
  border-radius: 50%;
  width: 300px;
  height: 300px;
  background-color: #0e214f;
  text-align: center;
  margin: 30px auto;
  position: relative;
  line-height: 300px;
}

.alfa-logo-holder span {
  line-height: 300px;
}

.alfa-logo-holder img {
  line-height: 300px;
  width: 60%;
}

#forgotPassword:hover {
  color: #ec217e;
  text-decoration: underline;
  cursor: pointer;
}
.default-design #forgotPassword:hover {
  color: #2c9199;
}
.auth-area {
  min-height: 89vh;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: start;
}

.auth-window {
  max-width: 400px;
  margin: 20px;
  margin-top: 10%;
  padding: 20px;
  font-weight: 600;
  font-size: 0.9rem;
}

.auth-window input {
  font-family: "WidgetBrain";
}

.auth-logo {
  user-select: none;
  width: 100%;
  height: 100%;
  margin-bottom: 20px;
}

.auth-logo img {
  width: 100%;
  height: 100%;
}

.alfa-design .auth-helpers,
.alfa-design .request-demo {
  font-size: 13px;
}

.auth-helpers {
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
  font-family: "WidgetBrain";
}

.auth-actions {
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
  align-items: center;
}
.auth-window
  .auth-form
  .auth-actions
  .md-theme-default.md-button:not([disabled]).md-primary.md-raised {
  background-color: #2c9199;
}
.auth-window
  .auth-form
  .auth-actions
  .md-theme-default.md-button:not([disabled]).md-primary.md-raised:hover {
  background-color: #30a6af !important;
}
.auth-window
  .auth-form
  .auth-actions
  .md-theme-default.md-button:not([disabled]).md-primary.md-raised:active,
.auth-window
  .auth-form
  .auth-actions
  .md-theme-default.md-button:not([disabled]).md-primary.md-raised:focus {
  background-color: #004851 !important;
}
.forgot-password-actions.default-forgot-password-actions .md-primary,
.error-dialog-actions.default-error-dialog-actions .md-primary {
  color: #004851 !important;
}
.error-dialog .md-dialog {
  min-height: 250px !important;
  max-height: 400px !important;
  width: 50%;
  max-width: 400px;
}
.error-dialog .error-dialog-content.default-error-dialog-content a {
  color: #004851 !important;
}
.request-demo {
  display: flex;
  justify-content: center;
}
.auth-form .request-demo .request-demo-link {
  color: #004851;
}
.auth-form .request-demo .request-demo-link:hover {
  color: #2c9199;
}
.request-demo-link {
  text-transform: uppercase;
  font-weight: 400;
}
.sso-submit-button {
  min-width: 40px;
  padding: 0;
}
.sso-button {
  min-height: 36px;
  height: 36px;
  padding: 0;
  position: relative;
  top: 2px;
  left: 8px;
  width: 162px;
}
.sso-button .multiselect__tags {
  min-height: 36px;
  height: 36px;
  border-radius: 0;
  padding-top: 5px;
}
.sso-button .multiselect__single {
  top: 2px;
}
.sso-button .multiselect__select:before {
  top: 56%;
}
.sso-submit-button .md-icon {
  padding-bottom: 4px;
}
.auth-window
  .auth-form
  .auth-actions
  .md-theme-default.md-button:not([disabled]).md-primary.md-raised.sso-submit-button.sso-submit-button-disabled {
  background-color: #adadb5;
  box-shadow: none;
  pointer-events: none;
}
.auth-window
  .auth-form
  .auth-helpers-part
  .md-theme-default.md-checkbox.md-checked
  .md-checkbox-container {
  background-color: #2c9199;
  border-color: #2c9199;
}
.auth-window
  .auth-form
  .md-input-container.md-theme-default.md-input-focused
  input,
.forgot-password-form.default-forgot-password-dialog-content
  .md-input-container.md-theme-default.md-input-focused
  input {
  color: #004851 !important;
}
.auth-window
  .auth-form
  .md-input-container.md-theme-default.md-input-focused
  label,
.forgot-password-form.default-forgot-password-dialog-content
  .md-input-container.md-theme-default.md-input-focused
  label {
  color: #004851 !important;
}
.auth-window
  .auth-form
  .md-input-container.md-theme-default.md-input-focused:after,
.forgot-password-form.default-forgot-password-dialog-content
  .md-input-container.md-theme-default.md-input-focused:after {
  background-color: #004851 !important;
}
.auth-window
  .auth-form
  .md-input-container.md-theme-default.md-input-focused
  .md-icon:not(.md-icon-delete) {
  color: #2c9199 !important;
}
.auth-window .auth-form .sso-button .multiselect__option--highlight,
.auth-window .auth-form .sso-button .multiselect__option--highlight:after {
  background-color: #004851 !important;
}
.intercom-lightweight-app-launcher {
  background: #2c9199 !important;
}
</style>
<style scoped>
/* .fade-enter-active, .fade-leave-active {
        transition: opacity 1s;
    }
    .fade-enter, .fade-leave-to !* .fade-leave-active below version 2.1.8 *! {
        opacity: 0;
        position: absolute;
    }*/

.temp-image {
  transition: all 1s;
  display: inline-block;
}
.list-complete-enter, .list-complete-leave-to
        /* .list-complete-leave-active до версии 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// Login.vue?013530e2